/**
 * Helpers puros do Hub de Recebimentos.
 * Sem React/serviços, para permitir teste unitário (vitest).
 */

/** Limite da coluna [Financial].[AcquirerCardTax].[TaxRate] — numeric(4,2). */
export const MAX_TAX_RATE = 99.99;

export type TaxRateParseResult =
  | { ok: true; value: number }
  | { ok: false; error: string };

/**
 * Valida e converte o texto digitado na edição inline da taxa.
 *
 * Aceita vírgula como separador decimal (teclado pt-BR) e arredonda para 2 casas,
 * que é a precisão da coluna — digitar 2,555 gravaria 2,56 no banco de qualquer
 * forma, então o valor é normalizado antes de sair da tela.
 */
export const parseTaxRateInput = (raw: string): TaxRateParseResult => {
  const trimmed = raw.trim().replace(',', '.');
  if (trimmed === '') return { ok: false, error: 'Informe a taxa' };

  const value = Number(trimmed);
  if (!Number.isFinite(value)) return { ok: false, error: 'Taxa inválida' };
  if (value < 0 || value > MAX_TAX_RATE) return { ok: false, error: `Taxa deve ser entre 0 e ${MAX_TAX_RATE}` };

  return { ok: true, value: Math.round(value * 100) / 100 };
};

/**
 * Rótulo do EC (estabelecimento comercial) na listagem. É o que distingue taxas
 * iguais de adquirentes com mais de um credenciamento; 0 é um EC válido cadastrado
 * (as linhas DEFAULT usam esse valor), então só ausência vira "—".
 */
export const formatEC = (ec: number | null | undefined): string =>
  ec === null || ec === undefined ? '—' : String(ec);
